import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { TextField } from 'redux-form-material-ui';
import RaisedButton from 'material-ui/RaisedButton';
// import QrReader from 'react-qr-reader';

class QRScanner extends Component {
  static propTypes = {
    onScan: PropTypes.func
  };

  constructor(props) {
    super(props);

    this.handleScan = this.handleScan.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  handleError(e) {
    console.log(e);
  }

  handleScan(data) {
    if (this.props.onScan) {
      this.props.onScan(data);
    }
  }

  renderTextField = props => {
    const { initValue, ...newProps } = props;
    return (<TextField hintText={props.label} floatingLabelText={props.label} errorText={props.touched && props.error} {...newProps} value={initValue} />);
  };

  render() {
    // const previewStyle = {
    //   width: 320,
    //   height:240
    // }
    // return <QrReader
    //     delay={100}
    //     style={previewStyle}
    //     onError={this.handleError}
    //     onScan={this.handleScan}
    //   />;

    const { handleSubmit, submitting } = this.props;
    const buttonText = (submitting) ? 'Saving...' : 'Save';

    return (
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col s12">
            <Field name="scan" component={this.renderTextField} floatingLabelText="Tracking Number" fullWidth />
          </div>
          <div className="col s12">
            <RaisedButton onClick={handleSubmit} fullWidth primary style={{color:'#fff'}}>{buttonText}</RaisedButton>
          </div>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: 'scanInForm'
})(QRScanner);


// WEBPACK FOOTER //
// ./src/components/QRScanner/index.js